import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Api } from "../Api/Api";

const AdminDashboard = () => {
  const [workers, setWorkers] = useState([]);
  const navigate = useNavigate();

  const [username, setUsername] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (user) {
      setUsername(user.username); // ✅ store username in state
    }
  }, []);

  const fetchWorkers = async () => {
    try {
      const res = await axios.get(`${Api}worker/get_all.php`);
      setWorkers(res.data);
    } catch (err) {
      toast.error("Failed to load workers");
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-blue-800 mb-2">Workers Bills</h1>
      </div>

      {/* Workers Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-2">
        {workers.length > 0 ? (
          workers.map((worker) => (
            <div
              key={worker.id}
              className="bg-white border border-blue-100 hover:border-blue-400 shadow-md rounded-2xl overflow-hidden transition duration-300 hover:shadow-xl cursor-pointer"
              onClick={() =>
                navigate(
                  `/admin/worker-details/${worker.id}/${worker.username}`
                )
              }
            >
              {/* Image */}
              {worker.photo ? (
                <img
                  src={worker.photo}
                  alt={worker.username}
                  className="w-full h-48 object-cover object-top"
                />
              ) : (
                <div className="w-full h-48 bg-gray-300 flex items-center justify-center text-gray-600 text-4xl">
                  ?
                </div>
              )}

              {/* Info */}
              <div className="p-4 text-center">
                <h2 className="text-lg font-semibold text-gray-800">
                  {worker.username}
                </h2>
                <p className="text-gray-600 text-sm mt-1">
                  Worker ID: #{worker.id}
                </p>
                <p className="text-gray-600 text-sm mt-1">
                  Created:{" "}
                  {worker.created_at
                    ? new Date(worker.created_at).toLocaleDateString()
                    : "N/A"}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center text-gray-500 py-10">
            No workers created yet.
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
